/** @jsx h */
/** @jsxFrag Fragment */
import { h } from "preact";
import { useEffect } from "preact/hooks";
import { FoldersContext } from "./dat.useFolderDispatch.tsx";

export interface DatFolderProps {
  path: string;
  title: string;
  children: any;
  open: boolean;
  onToggle: (p: string) => void;
  openAll: (p: string) => void;
  closeAll: (p: string) => void;
  hasSubfolders?: boolean;
  class?: string;
  style?: any;
}
export function DatFolder(props: DatFolderProps) {
  return (
    <li class={`folder ${!props.open ? "closed" : ""} ${props.class}`} style={props.style}>
      <div class="title">
        <span
          class="text"
          onClick={() => props.onToggle(props.path)}
          onKeyPress={() => props.onToggle(props.path)}
          role="button"
          tabIndex={0}
        >
          {props.title}
        </span>
        {props.hasSubfolders && (
          <span class="ctrl">
            <span onClick={() => props.openAll(props.path)}>+</span>
            <span onClick={() => props.closeAll(props.path)}>-</span>
          </span>
        )}
      </div>
      <ul>{props.children}</ul>
    </li>
  );
}

export interface DatSubFolderPropsBase {
  folders: FoldersContext;
  title: string;
  path: string;
  children?: any;
  hasSubfolders?: boolean;
}

export interface DatSubFolderProps extends DatSubFolderPropsBase {}
export function DatSubFolder(props: DatSubFolderProps) {
  const { state, dispatch } = props.folders;
  useEffect(() => {
    dispatch({ type: "add/path", payload: { path: props.path } });
  }, [1]);
  const hasSubfolders =
    props.hasSubfolders ||
    Object.keys(state.folders).filter((k) => k.startsWith(props.path)).length > 1;
  return (
    <DatFolder
      path={props.path}
      title={props.title}
      open={state.folders[props.path]}
      hasSubfolders={hasSubfolders}
      onToggle={() => dispatch({ type: "folder/toggle", payload: { path: props.path } })}
      openAll={() => dispatch({ type: "folder/openChildren", payload: { path: props.path } })}
      closeAll={() => dispatch({ type: "folder/closeChildren", payload: { path: props.path } })}
    >
      {props.children}
    </DatFolder>
  );
}

export interface DatFolderDebugProps {
  folders: FoldersContext;
}
export function DatFolderDebug(props: DatFolderDebugProps) {
  const entries = Object.entries(props.folders.state.folders).map(([k, v], i) => {
    return (
      <li key={i} class="cr">
        {v ? "o" : "c"} - {k}
      </li>
    );
  });

  return (
    <li class={`cr`}>
      <label>FolderDebug</label>
      <ul>
        <li class="cr">
          <label>state</label>
          <ul>{entries}</ul>
        </li>
      </ul>
    </li>
  );
}
